import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { ViewTransitionTypes, viewTransition } from "@/utils/view-transitions";

export const Route = createFileRoute(
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration",
)({
	component: RouteComponent,
	beforeLoad: ({ params, location }) => {
		// Check if we're at the exact configuration path (not a child route)
		const configurationPath = `/org-admin/${params.orgId}/configuration`;
		if (
			location.pathname === configurationPath ||
			location.pathname === `${configurationPath}/`
		) {
			throw redirect({
				to: "/org-admin/$orgId/configuration/jobTypes",
				params: {
					orgId: params.orgId,
				},
				replace: true,
				...viewTransition(ViewTransitionTypes.FADE),
			});
		}
	},
});

function RouteComponent() {
	return <Outlet />;
}
